"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swiftAidCurrency = exports.isSwiftAidSupported = void 0;
const country_1 = require("../enums/country");
const currency_1 = require("../enums/currency");
const isSwiftAidSupported = (country) => {
    return country === country_1.OrganizationCountry.GreatBritain;
};
exports.isSwiftAidSupported = isSwiftAidSupported;
const swiftAidCurrency = () => {
    return currency_1.AvailablePaymentCurrency.Gbp.toUpperCase();
};
exports.swiftAidCurrency = swiftAidCurrency;
